import * as React from 'react';
import './LoadingContainer.css';

import LoadingSpinner from './LoadingSpinner';
import logo from '../../logo.svg';

type LoadingContainerProps = {
    showLogo: boolean
}

type LoadingContainerState = {
    showLogo: boolean
}

class LoadingContainer extends React.Component<LoadingContainerProps, LoadingContainerState> {
    constructor(props: {showLogo: false}) {
        super(props);

        this.state = {
            showLogo: props.showLogo
        };
    }

    render() {
        let logoImg;

        if (this.state.showLogo)
            logoImg = <img src={logo} alt="Logo"/>


        return (
            <div className={"responsiveBox"}>
                {logoImg}
                <br/>
                <LoadingSpinner />
            </div>
        );
    }
}

export default LoadingContainer;
